export default "__VITE_ASSET__862351a9__"